<script setup>
import NewsThemeForm from '@frontJs/components/forms/projectManagement/apikom/NewsThemeForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { newsTheme, nextPosition } = defineProps({
    newsTheme: {
        type: [Object, null],
        required: false,
    },
    nextPosition: {
        type: Number,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="newsTheme">
            Mettre à jour le thème d'actualité #{{ newsTheme.id }} - Gestion de
            projet - Datakepler
        </title>

        <title v-else>
            Créer un thème d'actualité - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="newsTheme">
        Gestion de projet - Mettre à jour le thème d'actualité #{{
            newsTheme.id
        }}
    </PageTitle>

    <PageTitle v-else>
        Gestion de projet - Créer un thème d'actualité
    </PageTitle>

    <NewsThemeForm :news-theme="newsTheme" :next-position="nextPosition" />
</template>
